const HeadText = {
  0: "take-photo",
  1: "first-photo",
  2: "second-photo",
};

export default HeadText;
